// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"232":"9bc312bc","352":"051d58d0","988":"0e0ec959"}[chunkId] + ".chunk.css";
};